import React from 'react'
import { Text } from '@mantine/core'


interface DataItem {
    key: string
    value: string
    span?: boolean
}

interface Params {
    name: string
    column: number
    data: DataItem[]
    onCancelTradeClick?: () => void
    isCancelDisabled?: boolean
}

export function OverviewTradeBox({ name, column, data, onCancelTradeClick, isCancelDisabled }: Params) {
    const columns = Array.from({ length: column }, (_, colIndex) =>
        data.filter((item, index) => !item.span && index % column === colIndex)
    )

    return (
        <div className='trade-overview-box'  >
            <div className={name === 'Booking' ? 'trade-overview-box-booking-header' : 'trade-overview-box-header'}>
                <div className={name === 'Booking' ? 'trade-overview-box-booking-title' : 'trade-overview-box-title'}>
                    <Text className='trade-overview-box-title-text' >
                        {name}
                    </Text>

                </div>
                {name === 'Booking' && (
                    <div className='trade-overview-box-booking-cancel'>
                        <button disabled={isCancelDisabled} className='trade-overview-box-cancel-button' onClick={onCancelTradeClick}><Text className='trade-overview-box-cancel-button-text'>Cancel Trade</Text></button>
                    </div>
                )}
            </div>

            <div className='trade-overview-box-content'>
                {/* Render full-width rows first */}

                {data
                    .filter((item) => item.span)
                    .map((row, index) => (
                        <div
                            key={`${name}-span-${index}`}
                            className='trade-overview-box-row-full-width'>
                            <Text className='trade-overview-box-row-key'>
                                {row.key}
                            </Text>
                            <Text className='trade-overview-box-row-value'>
                                {row.value}
                            </Text>
                        </div>
                    ))}
                {/* Render remaining columns */}

                {columns.map((rows, index) => (
                    <div
                        key={name + " " + index}
                        className='trade-overview-box-column'
                    >
                        {rows.map((row, i) => (
                            <div
                                key={name + " " + index + " " + i}
                                className='trade-overview-box-cell'
                            >
                                <Text className='trade-overview-box-row-key' >
                                    {row.key}
                                </Text>
                                <Text className='trade-overview-box-row-value' >
                                    {row.value}
                                </Text>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
         
        </div>
    )
}
